import React from 'react';
import BoxProps from '@ch/common/components/box/types';
import { RadioStyleProps } from '@ch/common/components/form/radio/types';
import {
  IconDataPrivacy,
  IconBandAid,
  IconCheckCircle,
  IconClipboardText,
  IconFileArrowUp,
  IconFirstAid,
  IconNonFillUser,
  IconUserSwitch,
  IconQuestion,
  IconAdditionalInfo,
} from '@ch/common/components/icon';
import { IconProps } from '@ch/common/components/icon/types';
import TextProps from '@ch/common/components/text/types';
import { fieldGroups, FieldGroupsData, subFieldGroups } from './types';
import { ButtonProps } from '@ch/common/components/button/types';
import { CustomFlowId } from '@ch/common/types/data';

export const quizFieldOptionProps: BoxProps = {
  $m: [0, 0, 16],
};

export const quizFieldRadioProps: Omit<RadioStyleProps, 'name'> = {
  $size: 'sm',
};

export const desktopIconProps: IconProps = {
  $size: 32,
  $color: 'primary',
};

export const mobileIconProps: IconProps = {
  $size: 22,
  $color: 'primary',
};

export const titleProps: TextProps = {
  $color: 'primary',
  $m: [5, 0, 0],
  $size: 'md',
};

export const boxProps: BoxProps = {
  $bgColor: 'grayUltraLight',
  $p: [25, 25, 1],
  $radius: 4,
};

export const fieldGroupDefault = fieldGroups.TYPE;

// TODO replace with steps from backend
export const fieldGroupsData: FieldGroupsData = {
  [fieldGroups.TYPE]: {
    icon: IconUserSwitch,
    questions: [],
    fullWidth: true,
  },
  [fieldGroups.FORM]: {
    questions: [],
  },
  [fieldGroups.CONFIRM]: {
    icon: IconCheckCircle,
    questions: [],
    customLayout: true,
  },
};

export const subFieldGroupsData: { [key in subFieldGroups]?: React.FC } = {
  [subFieldGroups.INFO]: IconDataPrivacy,
  [subFieldGroups.GENERAL]: IconQuestion,
  [subFieldGroups.EVENT]: IconFirstAid,
  [subFieldGroups.PRODUCT]: IconBandAid,
  [subFieldGroups.PATIENT]: IconNonFillUser,
  [subFieldGroups.REPORT]: IconClipboardText,
  [subFieldGroups.DOC]: IconFileArrowUp,
  [subFieldGroups.ADDITIONAL_INFO]: IconAdditionalInfo,
};

export const controlIconProps: IconProps = {
  $size: 12,
};

export const controlButtonProps: ButtonProps = {
  $fullWidth: true,
  color: 'primary',
};

export const dpiRatio = 96 / 72;

export enum PdfExcludeSubTypes {
  WIDGET = 'Widget',
}
export enum PdfAnnotationFieldType {
  TEXT = 'Tx',
  BUTTON = 'Btn',
}

export const customFieldAttr = 'customAttrs';

// select doesn't work with false/null/etc
export const emptyValue = 'empty';

export const emailRegexp = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

// TODO: make this customizable in admin
export const preloadOptionsQuestions = [
  CustomFlowId.AGE_GROUP,
  CustomFlowId.AGE_UNIT,
  CustomFlowId.ROUTE_ADMIN,
] as string[];

export const analyticsAttribute = {
  PERSONA: 'person_type',
  REPORTER_COUNTRY: 'reporter_country',
  CONFIRMATION_EMAIL_CHECKBOX: 'confirmation_email_checkbox',
  FOCUS_DROPDOWN: 'react-select-',
};

const autoSuggestionFields = {
  REPORTER_STREET: 'reporter_street',
  PHYSICIAN_STREET: 'physician_street',
  VACC_FACILITY_ADDRESS: 'vacc_facility_adress',
};

export const addressPopulationObject = {
  [autoSuggestionFields.REPORTER_STREET]: {
    city: 'reporter_city',
    postalCode: 'reporter_postcode',
    country: '',
    state: '',
  },
  [autoSuggestionFields.PHYSICIAN_STREET]: {
    city: 'physician_city',
    postalCode: 'physician_postcode',
    country: 'physician_country',
    state: 'physician_state',
  },
  [autoSuggestionFields.VACC_FACILITY_ADDRESS]: {
    city: 'vacc_facility_city',
    postalCode: 'vacc_facility_post',
    country: 'vacc_facility_country',
    state: 'vacc_facility_state',
  },
};
